(() => {
  const root = document.getElementById('puricura-customer-type');
  if (!root) return;

  const typeKey = 'puricura_customer_type';
  const modal = root.querySelector('[data-puricura-modal]');
  const current = root.querySelector('[data-puricura-current]');
  const blocked = root.querySelector('[data-puricura-blocked]');
  const privateUrl = root.dataset.privateUrl;
  const businessUrl = root.dataset.businessUrl;
  const cleanersUrl = '/collections/reinigungschemikalien';
  const b2bHandles = new Set(
    (root.dataset.b2bHandles || '').split(',').filter(Boolean)
  );

  const privateHiddenCollections = new Set([
    '/collections/rohr-und-abflussreiniger',
    '/collections/schimmelentferner',
    '/collections/fettloser',
    '/collections/backofen-und-grillreiniger'
  ]);

  const getType = () => localStorage.getItem(typeKey) || '';

  const setCookie = value => {
    document.cookie =
      `${typeKey}=${value}; path=/; max-age=31536000; SameSite=Lax`;
  };

  const saveAttributes = async () => {
    const business = getType() === 'business';

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          Bestelltyp: business ? 'Firma' : 'Privat',
          Firma: ''
        }
      })
    }).catch(() => {});
  };

  const markB2BForms = () => {
    if (root.dataset.productSegment !== 'b2b') return;

    document
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach(form => {
        if (
          form.querySelector(
            '[name="properties[_puricura_segment]"]'
          )
        ) {
          return;
        }

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_puricura_segment]';
        input.value = 'B2B';
        form.appendChild(input);
      });
  };

  const productHandle = href => {
    try {
      const match = new URL(href, location.origin)
        .pathname
        .match(/^\/products\/([^/?#]+)/);

      return match ? match[1] : '';
    } catch (_) {
      return '';
    }
  };

  /*
   * Sucht auch dynamisch erzeugte Inhalte innerhalb offener Shadow Roots.
   * Dies ist insbesondere für die Essential-Upsell-App notwendig.
   */
  const searchRoots = () => {
    const roots = [document];

    const visit = searchRoot => {
      searchRoot.querySelectorAll('*').forEach(element => {
        if (
          element.shadowRoot &&
          !roots.includes(element.shadowRoot)
        ) {
          roots.push(element.shadowRoot);
          visit(element.shadowRoot);
        }
      });
    };

    visit(document);
    return roots;
  };

  /*
   * Ermittelt exakt die einzelne Cross-Selling-Produktkarte.
   * Der restliche Upsell-Bereich bleibt dadurch bestehen.
   */
  const upsellCardFor = link => {
    const essentialUpsellCard = link.closest(
      '[data-essential-upsell-element="product"]'
    );

    if (essentialUpsellCard) {
      return essentialUpsellCard;
    }

    let element = link;
    let card = null;

    for (
      let depth = 0;
      depth < 10 && element.parentElement;
      depth += 1
    ) {
      element = element.parentElement;

      const handles = new Set(
        Array.from(
          element.querySelectorAll('a[href*="/products/"]')
        )
          .map(productLink => productHandle(productLink.href))
          .filter(Boolean)
      );

      if (handles.size > 1) break;

      if (
        handles.size === 1 &&
        (
          element.querySelector('button') ||
          element.matches('li, article')
        )
      ) {
        card = element;
      }
    }

    return card || link.closest('li, article');
  };

  const setUpsellHidden = (card, hide) => {
    if (!card) return;

    if (hide) {
      if (
        !card.hasAttribute('data-puricura-previous-display')
      ) {
        card.setAttribute(
          'data-puricura-previous-display',
          card.style.getPropertyValue('display')
        );
      }

      card.setAttribute(
        'data-puricura-upsell-hidden',
        'true'
      );

      card.style.setProperty(
        'display',
        'none',
        'important'
      );

      return;
    }

    if (
      card.getAttribute('data-puricura-upsell-hidden') !==
      'true'
    ) {
      return;
    }

    const previousDisplay =
      card.getAttribute('data-puricura-previous-display') ||
      '';

    if (previousDisplay) {
      card.style.setProperty('display', previousDisplay);
    } else {
      card.style.removeProperty('display');
    }

    card.removeAttribute('data-puricura-upsell-hidden');
    card.removeAttribute('data-puricura-previous-display');
  };

  /*
   * Privat:
   * B2B-Produkte aus dem Cross-Selling entfernen.
   *
   * Firma:
   * Alle Cross-Selling-Produkte anzeigen.
   */
  const applyUpsellVisibility = () => {
    const isPrivate = getType() === 'private';

    searchRoots().forEach(searchRoot => {
      searchRoot
        .querySelectorAll(
          '[data-puricura-upsell-hidden="true"]'
        )
        .forEach(card => {
          if (!isPrivate) {
            setUpsellHidden(card, false);
          }
        });

      searchRoot
        .querySelectorAll(
          [
            '[data-essential-upsell-funnel-id]',
            '[data-essential-upsell-offer-type]',
            'essential-upsell-cross-sell-app-block',
            'essential-upsell-app-embed'
          ].join(', ')
        )
        .forEach(upsell => {
          const upsellRoot =
            upsell.shadowRoot || upsell;

          upsellRoot
            .querySelectorAll('a[href*="/products/"]')
            .forEach(link => {
              const handle = productHandle(link.href);

              if (!handle) return;

              setUpsellHidden(
                upsellCardFor(link),
                isPrivate && b2bHandles.has(handle)
              );
            });
        });
    });
  };

  const applyPrivateVisibility = () => {
    const isPrivate = getType() === 'private';

    document
      .querySelectorAll('[data-puricura-product-card]')
      .forEach(card => {
        const hide =
          isPrivate &&
          card.dataset.shopSegment === 'b2b';

        const gridItem =
          card.closest('li.js-pagination-result') ||
          card.closest('li') ||
          card;

        gridItem.classList.toggle(
          'puricura-segment-hidden',
          hide
        );
      });

    document
      .querySelectorAll('a[href*="/products/"]')
      .forEach(link => {
        const handle = productHandle(link.href);

        if (
          !handle ||
          link.closest('[data-puricura-product-card]')
        ) {
          return;
        }

        const item = link.closest('li');

        if (item) {
          item.classList.toggle(
            'puricura-segment-hidden',
            isPrivate && b2bHandles.has(handle)
          );
        }
      });

    document
      .querySelectorAll('a[href*="/collections/"]')
      .forEach(link => {
        let path;

        try {
          path = new URL(link.href, location.origin)
            .pathname
            .replace(/\/$/, '');
        } catch (_) {
          return;
        }

        if (!privateHiddenCollections.has(path)) return;

        const item = link.closest('li');

        if (item) {
          item.classList.toggle(
            'puricura-segment-hidden',
            isPrivate
          );
        } else {
          link.classList.toggle(
            'puricura-segment-hidden',
            isPrivate
          );
        }
      });

    const currentPath =
      location.pathname.replace(/\/$/, '');

    if (
      isPrivate &&
      privateHiddenCollections.has(currentPath)
    ) {
      location.replace(cleanersUrl);
    }

    applyUpsellVisibility();
  };

  const routeCollections = () => {
    const type = getType();

    if (!type) return;

    const destination = cleanersUrl;

    document
      .querySelectorAll('a[href]')
      .forEach(link => {
        let path;

        try {
          path = new URL(
            link.href,
            location.origin
          ).pathname;
        } catch (_) {
          return;
        }

        if (
          path === '/collections/reinigungschemikalien' ||
          path === privateUrl ||
          path === businessUrl
        ) {
          link.href = destination;
        }
      });

    const path = location.pathname.replace(/\/$/, '');

    if (
      path !== destination &&
      (
        path === '/collections/reinigungschemikalien' ||
        (type === 'private' && path === businessUrl) ||
        (type === 'business' && path === privateUrl)
      )
    ) {
      location.replace(destination);
    }
  };

  const resetModal = () => {
    modal.hidden = false;
  };

  const sync = () => {
    const type = getType();
    const business = type === 'business';

    current.textContent = business
      ? 'Firma'
      : type === 'private'
        ? 'Privat'
        : 'Kundentyp wählen';

    root
      .querySelectorAll('[data-puricura-quick-select]')
      .forEach(button => {
        const active =
          button.dataset.puricuraQuickSelect === type;
        button.setAttribute('aria-pressed', String(active));
      });

    document.dispatchEvent(
      new CustomEvent('puricura:customer-type', {
        detail: { type }
      })
    );

    blocked.hidden = !(
      type === 'private' &&
      root.dataset.productSegment === 'b2b'
    );

    markB2BForms();
    applyPrivateVisibility();
    routeCollections();
  };

  const choosePrivate = async () => {
    localStorage.setItem(typeKey, 'private');
    setCookie('private');
    modal.hidden = true;

    await saveAttributes();
    sync();

    if (root.dataset.productSegment === 'b2b') {
      location.href = privateUrl;
    }
  };

  const chooseBusiness = async () => {
    localStorage.setItem(typeKey, 'business');
    setCookie('business');
    modal.hidden = true;

    await saveAttributes();
    sync();
  };

  /*
   * Überwacht dynamisch geladene Shopify- und Upsell-Inhalte.
   */
  const observedRoots = new WeakSet();
  let visibilityFrame = 0;

  const scheduleDynamicSync = () => {
    if (visibilityFrame) return;

    visibilityFrame = requestAnimationFrame(() => {
      visibilityFrame = 0;
      markB2BForms();
      applyPrivateVisibility();
      routeCollections();
      observeDynamicContent();
    });
  };

  const observeDynamicContent = () => {
    searchRoots().forEach(searchRoot => {
      if (observedRoots.has(searchRoot)) return;

      observedRoots.add(searchRoot);

      const target =
        searchRoot === document
          ? document.body
          : searchRoot;

      if (!target) return;

      new MutationObserver(
        scheduleDynamicSync
      ).observe(target, {
        childList: true,
        subtree: true
      });
    });
  };

  root
    .querySelectorAll('[data-puricura-quick-select]')
    .forEach(button => {
      button.addEventListener('click', () => {
        if (button.dataset.puricuraQuickSelect === 'business') {
          chooseBusiness();
        } else {
          choosePrivate();
        }
      });
    });

  root
    .querySelector('[data-puricura-select="private"]')
    .addEventListener('click', choosePrivate);

  root
    .querySelector('[data-puricura-select="business"]')
    .addEventListener('click', chooseBusiness);

  root
    .querySelector('[data-puricura-open]')
    .addEventListener('click', () => {
      resetModal();
      modal.hidden = false;
    });

  root
    .querySelector('[data-puricura-close]')
    .addEventListener('click', () => {
      if (getType()) {
        modal.hidden = true;
      }
    });

  document.addEventListener(
    'submit',
    event => {
      const form = event.target;

      if (
        form.matches('form[action*="/cart/add"]') &&
        root.dataset.productSegment === 'b2b' &&
        getType() !== 'business'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        blocked.hidden = false;
        resetModal();
        modal.hidden = false;
      }
    },
    true
  );

  /*
   * Der normale Shopify-Checkout bleibt aktiv.
   * Blockiert wird nur:
   * 1. wenn noch kein Kundentyp gewählt wurde;
   * 2. wenn Privat mit einem B2B-Artikel bestellen will.
   */
  document.addEventListener(
    'click',
    event => {
      const checkout = event.target.closest(
        [
          '[name="checkout"]',
          'a[href*="/checkout"]',
          'button[id*="checkout"]',
          '.cart__checkout'
        ].join(', ')
      );

      if (!checkout) return;

      const type = getType();
      const b2bInCart =
        root.dataset.cartHasB2b === 'true';

      if (
        !type ||
        (type === 'private' && b2bInCart)
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (
          type === 'private' &&
          b2bInCart
        ) {
          blocked.hidden = false;
        }

        resetModal();
        modal.hidden = false;
      }
    },
    true
  );

  observeDynamicContent();

  if (!getType()) {
    resetModal();
    modal.hidden = false;
  }

  sync();
})();